<template>
    <section>
        <card>
            <div class="top">
                <div class="line"></div>
                <div class="title">角色管理</div>
            </div>
            <div class="block">
                <div class="left">
                    <div class="ipt-box">
                        <input type="text" class="ipt" placeholder="请输入角色名" maxlength="10" :value="roleName" @blur="bindChange($event)">
                        <div type="primary" size="small" class="btn" @click="addRole">+添加角色</div>
                    </div>
                    <div class="list" v-for="(item,index) in roleList" :key="index" @click="setIndex(item,index)">
                        <div class="role-name" :class="index==active?'active':''">{{item.roleName}}</div>
                        <div class="del" @click.stop="deleteRow(item)">删除</div>
                    </div>
                </div>
                <div class="right">
                    <div class="right-title">
                        <div>勾选该角色需要的权限</div>
                        <div type="primary" size="small" class="btn btn2" @click="saveAuth">保存</div>
                    </div>
                    <el-tree class="tree-right-role" ref="rightsTree" :data="authList" show-checkbox node-key="id" @node-click="handleNodeClick2" :default-checked-keys="choosedIds" :default-expanded-keys="choosedIds" default-expand-all>
                    </el-tree>
                </div>
            </div>
        </card>
    </section>
</template>

<style lang="less" scoped>
.tree-right-role {
    height: 650px;
    overflow-y: scroll;
}
/*修改滚动条样式*/
.tree-right-role::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    /**/
}
.tree-right-role::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
    border-radius: 2px;
}
.tree-right-role::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 5px;
}
.tree-right-role::-webkit-scrollbar-thumb:hover {
    background: #333;
}
.tree-right-role::-webkit-scrollbar-corner {
    background: #179a16;
}

.top {
    display: flex;
    align-items: center;
}
.line {
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #3572e2;
    margin-right: 12px;
}
.title {
    color: #333333;
    font-size: 18px;
    font-weight: 500;
}
.block {
    margin-top: 22px;
    display: flex;
    height: 760px;
    overflow: auto;
    border: 1px solid #dce0e4;

    .left {
        background: #f5f6f7;
        width: 540px;
        padding: 26px 0 0 38px;

        .ipt-box {
            display: flex;
            margin-bottom: 30px;

            .ipt {
                width: 340px;
                height: 42px;
                border: 1px solid #dddddd;
                background: white;
                color: #666666;
                font-size: 14px;
                text-indent: 15px;
                margin-right: 12px;
                box-sizing: border-box;
            }

            .ipt:focus {
                outline: 1px solid #3572e2;
            }
        }

        .list {
            width: 320px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .role-name {
                font-size: 14px;
                color: #737e8b;
                line-height: 20px;
                margin-bottom: 12px;
            }

            .active {
                color: #3572e2;
                font-weight: 500;
            }

            .role-name:hover {
                color: #3572e2;
            }

            .del {
                color: #333333;
            }

            .del:hover {
                color: #000;
            }
        }
    }

    .right {
        width: 750px;

        .right-title {
            padding: 20px 26px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 16px;
            color: #737e8b;
            border-bottom: 1px solid #edeff1;
        }
    }
}
.btn {
    width: 100px;
    height: 42px;
    background: #3572e2;
    text-align: center;
    line-height: 42px;
    color: white;
    font-size: 14px;
    cursor: pointer;
}
.btn2 {
    height: 36px;
    line-height: 36px;
}
</style>
<style>
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3572e2;
    border-color: #3572e2;
}
.el-checkbox__inner:hover {
    border-color: #3572e2;
}
</style>

<script>
import api from "plus/api/index";
import card from "components/card";

export default {
    name: "privilege.role.list",
    data() {
        return {
            roleList: [],
            active: 0,
            roleName: "",
            authList: [],
            activeRole: {},
            ids: [],
            names: [],
            choosedIds: [],
        };
    },
    components: {
        card: card,
    },
    created() {
    },
    activated(){
        this.getRoles();
        this.getAuth();
    },
    methods: {
        handleNodeClick2(nodes, node, self) {
            this.choosedIds = [node.data.offerSvcCode];
        },
        deleteRow(item) {
            let tips="是否删除"
            if(item.menuInfoList.length>0) tips = "该角色下还存在绑定成员，请核实之后，再进行删除"
            this.$confirm(tips, "提示", {
                confirmButtonText: item.menuInfoList.length>0 ? "继续删除" :'删除',
              confirmButtonClass:'confirmBtn',
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                api.role.delRole({ id: item.id, roleName: item.roleName }).then(
                    () => {
                        this.$message.success("删除成功");
                        this.getRoles();
                    },
                    (err) => {

                        // this.$message.error(err.data.msg);
                    }
                );
            });
        },
        getRoles() {
            api.role
                .getRoleList()
                .then((res) => {
                    this.roleList = res.data.data || [];
                    this.activeRole = this.roleList[this.active];
                    let arr = [];
                    if (this.activeRole.menuInfoList.length) {
                        this.activeRole.menuInfoList.map((item) => {
                            arr.push(item.id);
                        });
                    }
                    this.choosedIds = arr;
                    this.$nextTick(() => {
                        this.$refs.rightsTree.setCheckedKeys(this.choosedIds);
                    });
                })
                .catch((err) => {
                    ;
                });
        },
        setIndex(item, index) {
            this.active = index;
            this.activeRole = item;
            this.choosedIds = [];
            let arr = [];
            if (item.menuInfoList.length) {
                item.menuInfoList.map((item) => {
                    arr.push(item.id);
                });
            }
            this.choosedIds = arr.length ? arr : [];
            this.$nextTick(() => {
                this.$refs.rightsTree.setCheckedKeys(this.choosedIds);
            });
        },
        addRole() {
          ;
            if (!this.roleName.trim()) {
                this.$message.warning("请填写角色名");
                return;
            }
            if (this.roleName.length > 10) {
                this.$message.warning("最长10个字符");r
                return
            }
            api.role.addRole({ roleName: this.roleName.trim() }).then(
                (res) => {
                    this.$message.success("添加成功");
                    this.getRoles();
                    this.roleName = "";
                },
                (err) => {

                }
            );
        },
        bindChange(e) {
            this.roleName = e.target.value;
        },
        getAuth() {
            api.role.getRoleAuth().then(
                (res) => {
                  ;
                    this.authList = res.data.data || [];

                    this.loop(this.authList);
                },
                (err) => {

                  // this.$message.error(err.data.msg);
                }
            );
        },
        loop(item) {
            item.map((sub) => {
                sub.label = sub.menuName;
                if (!sub.children.length) {
                    sub.isLeaf = true;
                } else {
                    sub.isLeaf = false;
                    this.loop(sub.children);
                }
            });
        },
        handleCheckChange(data, checked, indeterminate) {
            if (checked) {
                this.ids.push(data.id);
                this.names.push(data.label);
            } else {
                this.ids.splice(this.ids.indexOf(data.id), 1);
                this.names.splice(this.names.indexOf(data.label), 1);
            }
        },
        saveAuth() {
          ;
          this.ids = []
          this.names = []
          const checkedNodes = this.$refs.rightsTree.getCheckedNodes(false,true)
          for (let item of checkedNodes) {
            this.ids.push(item.id)
            this.names.push(item.menuName)
          }
          if (!this.ids.length || !this.names.length) {
              this.$message.warning("请勾选角色需要的权限");
              return;
          }
          let obj = {
              id: this.activeRole.id,
              roleName: this.activeRole.roleName,
              menuId: this.ids,
              menuName: this.names,
          };
          api.role.authRole(obj).then(
              (res) => {
                ;
                  this.$message.success("保存成功");
                  this.getRoles()
              },
              (err) => {

                // this.$message.error(err.data.msg);
              }
          );
        },
    },
};
</script>
